import React from 'react';

import { Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender } from '@philips-emr/tws-core/lib/client';
import { RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames } from '../../codegen';
import { HistoricoCancelamentosAliases } from '../../codegen/constants/aliases/historico-cancelamentos-aliases';

@Controller({ fragment: FragmentNames.HISTORICO_CANCELAMENTOS })
export default class HistoricoCancelamentosController {

  @OnDynamicContentRender(HistoricoCancelamentosAliases.CUSTOM_CARD)
  onDynamicContentRender({ data, render }: RenderEvent): void {
    const { ieStatus } = data as { ieStatus: number };

    const props: { [key: number]: {} } = {
      1: { icon: StampIcon.CLOCK, color: Color.SAFETY_NEUTRAL },
      2: { icon: StampIcon.CHECK, color: Color.SAFETY_GREEN },
      3: { icon: StampIcon.WARNING, color: Color.SAFETY_YELLOW },
      4: { icon: StampIcon.WARNING, color: Color.SAFETY_BLUE },
      5: { icon: StampIcon.CANCELED_OUTLINE, color: Color.SAFETY_ORANGE },
      6: { icon: StampIcon.CANCELED, color: Color.SAFETY_RED },
    };

    render(() => <Stamp {...props[ieStatus]} label={`@beneficiary.status-solicitacao-rescisao-contrato/${ieStatus}`} />);
  }

}
